<script>
/**
 * 如果需要轮播传 swiper
 * 否则传html标签名称 例如：div
 */
export default {
  functional: true,
  props: {
    tag: String
  },
  render(h, ctx) {
    const { props, data } = ctx;
    const slots = ctx.slots();
    if (props.tag === 'swiper') {
      const children = (slots.default || [])
        .filter((v) => !v.isComment)
        .map((vnode) => h('van-swipe-item', [vnode]));

      if (slots.indicator) {
        data.scopedSlots = {
          indicator: ctx.scopedSlots.indicator
        };
      }
      return h('van-swipe', data, children);
    }
    // 不是swiper 过滤掉和swiper相关的属性
    const attrs = {};
    for (const key in data.attrs) {
      if (Object.prototype.hasOwnProperty(props, key)) {
        attrs[key] = data.attrs[key];
      }
    }
    data.attrs = attrs;
    return h(props.tag, data, slots.default);
  }
};
</script>
